import { ENDPOINT, requestOptions } from '../utils/settings'

import type { ImageBase64 } from '../utils/types'

export async function cropImage(file: File, subImages: number[][]): Promise<ImageBase64[]> {
    try {
        const formdata = new FormData()
        formdata.append('image', file, 'file.png')
        formdata.append('subImages', JSON.stringify(subImages))
        const myHeaders = new Headers()
        myHeaders.append('Accept', 'application/json')

        const imagesBase64 = (await fetch(`${ENDPOINT}/image/crop`, {
            ...requestOptions,
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        }).then(response => response.json())) as ImageBase64[]
        return imagesBase64
    } catch (error) {
        console.error(error)
        return []
    }
}

export async function cropBase64Image(
    file: string,
    subImages: number[][]
): Promise<{
    images: ImageBase64[]
}> {
    try {
        const formdata = new FormData()
        formdata.append('imageBase64', file)
        formdata.append('subImages', JSON.stringify(subImages))
        const myHeaders = new Headers()
        myHeaders.append('Accept', 'application/json')

        const obj = (await fetch(`${ENDPOINT}/imageBase64/crop`, {
            ...requestOptions,
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        })
            .then(response => response.json())
            .catch(error => {
                console.error(error)
                return {
                    images: []
                }
            })) as {
            images: string[]
        }
        return obj
    } catch (error) {
        return {
            images: []
        }
    }
}
